var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSendIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.17196 3.15899C4.92086 3.0334 4.63955 2.98081 4.36004 3.00719C4.08053 3.03357 3.81403 3.13786 3.59086 3.30821C3.36769 3.47856 3.1968 3.70812 3.09764 3.97078C2.99849 4.23344 2.97504 4.51866 3.02996 4.79399L7.23896 19.344C7.31744 19.6151 7.47084 19.8586 7.68152 20.0465C7.89221 20.2344 8.15163 20.359 8.42996 20.406L25.5 23.265C26.304 23.424 26.304 24.576 25.5 24.735L8.42996 27.594C8.15163 27.641 7.89221 27.7656 7.68152 27.9535C7.47084 28.1413 7.31744 28.3848 7.23896 28.656L3.02996 43.206C2.97504 43.4813 2.99849 43.7665 3.09764 44.0292C3.1968 44.2919 3.36769 44.5214 3.59086 44.6918C3.81403 44.8621 4.08053 44.9664 4.36004 44.9928C4.63955 45.0192 4.92086 44.9666 5.17196 44.841L44.172 25.341C44.4208 25.2163 44.63 25.0248 44.7762 24.788C44.9224 24.5512 44.9999 24.2783 44.9999 24C44.9999 23.7217 44.9224 23.4488 44.7762 23.212C44.63 22.9752 44.4208 22.7837 44.172 22.659L5.17196 3.15899Z",
    fill: "#1B1B1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendIcon);
export default __webpack_public_path__ + "static/media/send-icon.d39f436007ee0b5229cb8377943f4824.svg";
export { ForwardRef as ReactComponent };